export default {
  dashboard: 'Dashboard',
  system: 'System Management',
  user: 'User Management',
  role: 'Role Management',
  profile: 'Profile',
  orderCenter: 'Order Center',
  orderManagement: 'Order Management',
  orderDetail: 'Order Detail',
  inquiryManagement: 'Inquiry Management',
  freightRateQuery: 'Freight Rate Query',
  userCenter: 'User Center',
  userProfile: 'User Profile',
  userManagement: 'User Management',
  roleManagement: 'Role Management',
  staffManagement: 'Staff Management',
  positionManagement: 'Position Management',
  companyCenter: 'Company Management',
  companyProfile: 'Company Profile',
  companyDataManagement: 'Company Data Management',
  companyCertification: 'Company Certification',
  basicDataCenter: 'Basic Data Maintenance',
  portManagement: 'Port Management',
  carrierManagement: 'Carrier Management',
  routeManagement: 'Route Management',
  containerManagement: 'Container Management',
  chargeManagement: 'Charge Management',
  shipAgentManagement: 'Ship Agent Management',
  terminalManagement: 'Terminal Management',
  productMaterialData: 'Product Material Data',
  overseasWarehouseManagement: 'Warehouse Management',
  countryRegionManagement: 'Country/Region Management',
  chinaAdministrativeDivision: 'Administrative Division',
  zipcodeManagement: 'Zipcode Management',
  shipDataManagement: 'Ship Data Management',
  tradeTermsManagement: 'Trade Terms Management',
  transportTermsManagement: 'Transport Terms Management',
  calculationUnitManagement: 'Calculation Unit Management',
  packageUnitManagement: 'Package Unit Management',
  superRateSystem: 'Super Rate System',
  blAdditionCenter: 'BL Addition Center',
  controlTowerPanel: 'Control Tower Panel',
  settlement: 'Settlement',
  settlementStatement: 'Settlement Statement'
}
